// components/dialogs/OptionDialog.jsx

import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
  Box,
  TextField,
} from "@mui/material";

import Api from "../../Api/Api";
import { toast } from "sonner";

export default function OptionDialog({
  carrierDialog,
  setCarrierDialog,
  newCarrier,
  setNewCarrier,
  fetchCarriers,
}) {
  return (
    <Dialog
      open={carrierDialog}
      onClose={() => setCarrierDialog(false)}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Add Carrier</DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          label="Carrier Name"
          value={newCarrier}
          onChange={(e) => setNewCarrier(e.target.value)}
          sx={{ mt: 2 }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setCarrierDialog(false)}>Cancel</Button>

        <Button
          variant="contained"
          onClick={async () => {
            try {
              await Api.post("/dashboard/add-carrier", {
                carrier_name: newCarrier,
              });

              await fetchCarriers();

              setNewCarrier("");
              setCarrierDialog(false);
              toast.success("Carrier Added");
            } catch (err) {
              console.error(err);
              toast.error(
                err.response?.data?.message || "Failed to add carrier",
              );
            }
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
